'use strict';
var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/try-to-string.js
// module id = 92
// module chunks = 13